module.exports = __webpack_public_path__ + "static/img/Joe-Tapine.6ba9be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Tapine.jpg
// module id = hc9N
// module chunks = 0